module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-md-editor', {
    attrs: {
      "height": "600px",
      "left-toolbar": _vm.leftToolbar,
      "right-toolbar": _vm.rightToolbar,
      "toolbar": _vm.customToolbar,
      "disabled-menus": []
    },
    model: {
      value: (_vm.mdText),
      callback: function($$v) {
        _vm.mdText = $$v
      },
      expression: "mdText"
    }
  }), _vm._v(" "), _c('ImageConf', {
    ref: "imgConf",
    attrs: {
      "showData": _vm.imgConfData
    },
    on: {
      "returnConf": function($event) {
        return _vm.fillImageContent($event)
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-6073b81a!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/WelcomeSettings/Markdown.vue
// module id = af1r
// module chunks = 4